import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";
import adjustEvents from "./json/adjust-events.json";
import {
	getAnalyticsOptions,
	identify,
	track,
	trackLink,
} from "./utils/analytics";
import { stickyHeader } from "./utils/header";
import {
	checkFetchForError,
	makeSlider,
	parseFetchResponse,
} from "./utils/helpers";

(function() {
	var optInAnalytics = document
		.getElementById("opt-in-analytics")
		.getAttribute("data-opt-in-analytics");

	setTimeout(function() {
		document.body.classList.remove("preload");
	}, 100);

	window.analytics.addSourceMiddleware(({ payload, next }) => {
		if (payload.obj.context) {
			try {
				const traitsData =
					window.localStorage.getItem("ajs_user_traits");
				const traits = traitsData ? JSON.parse(traitsData) : {};
				payload.obj.context.traits =
					typeof traits === "object" && traits !== null ? traits : {};
			} catch (error) {
				console.warn(
					"Failed to parse user traits from localStorage:",
					error
				);
				payload.obj.context.traits = {};
			}
		}
		next(payload);
	});

	var userId = document.getElementById("user-id")
		? document.getElementById("user-id").getAttribute("data-user-id")
		: null;
	var pageUrlBase = window.location.hostname;
	var pageUrlPath = window.location.pathname;
	var pageTrackObj = { url_base: pageUrlBase };
	var anonymousId = document.getElementById("anonymous-id")
		? document.getElementById("anonymous-id").value
		: null;
	var urlParams = new URLSearchParams(window.location.search);

	function getCampaignParams() {
		const keys = [
			"utm_source",
			"utm_medium",
			"utm_campaign",
			"utm_content",
			"utm_term",
		];
		const params = {};
		const firstParams = {};
		keys.forEach((k) => {
			const v = urlParams.get(k);
			if (v) {
				params[k + " [last touch]"] = v;
				firstParams[k + " [first touch]"] = v;
			}
		});
		return { params, firstParams };
	}

	function getPageTrackObj() {
		if (document.getElementById("analytics-info")) {
			return JSON.parse(
				document
					.getElementById("analytics-info")
					.getAttribute("data-analytics-info")
			);
		}
		if (["/", "/home"].includes(pageUrlPath))
			return { url_base: pageUrlBase, page_name: "home page" };
		if (pageUrlPath === "/hulu")
			return { url_base: pageUrlBase, page_name: "hulu" };
		if (pageUrlPath === "/tv")
			return { url_base: pageUrlBase, page_name: "hulu tv" };
		return {
			url_base: pageUrlBase,
			page_name: pageUrlPath.split("/").pop().replace("-", " "),
		};
	}

	function enhanceLoginForm(trackFn) {
		const loginForm = document.getElementById("login-form");
		if (!loginForm) return;

		if (!navigator.cookieEnabled) {
			const cookieWarning = document.createElement("p");
			cookieWarning.innerHTML = `
        <p role="alert" class="alert alert--warning alert--extra-padding alert--with-icon">
          <img src="${CDN}/img/icons/alert-circle.svg" alt="">
          <span>Looks like you've disabled cookies. Please enable cookies before logging into your account. Read our <a href="/privacy" class="f-link" target="_blank">Privacy Policy</a> to learn more.</span>
        </p>`;
			document
				.querySelector(".login__submit-container")
				.insertBefore(
					cookieWarning,
					document.getElementById("submit-login")
				);
		}

		const hiddenAnon = document.createElement("input");
		hiddenAnon.type = "hidden";
		hiddenAnon.name = "anonymousId";
		hiddenAnon.value = anonymousId;
		loginForm.appendChild(hiddenAnon);

		document
			.getElementById("submit-login")
			.addEventListener("click", () => {
				trackFn("Login Client Button Click", { category: "login" });
			});
	}

	// ---------------- Segment (analytics.js + mixpanel + Adjust) ----------------
	function initSegment() {
		window.analytics.ready(() => {
			const { params, firstParams } = getCampaignParams();
			if (Object.keys(params).length) {
				window.mixpanel.people.set(params);
				window.mixpanel.people.set_once(firstParams);
				window.mixpanel.register(params);
			}

			if (userId && optInAnalytics) identify(userId);

			if (typeof window.analytics.user === "function") {
				if (anonymousId)
					window.analytics.user().anonymousId(anonymousId);
				window.optimizelyAnonymousId = window.analytics
					.user()
					.anonymousId();
			}

			pageTrackObj = getPageTrackObj();
			window.analytics.page({ app: "Growth" }, getAnalyticsOptions());
			if (pageTrackObj.page_name)
				track("Page Viewed", { ...pageTrackObj });

			document
				.querySelectorAll("[data-old-tracking-action]")
				.forEach((el) => {
					const action = el.getAttribute("data-old-tracking-action");
					const props = el.getAttribute(
						"data-old-tracking-properties"
					);
					const obj = props ? JSON.parse(props) : {};
					trackLink(el, action, obj, true);
				});

			document
				.querySelectorAll("[data-tracking-action]")
				.forEach((el) => {
					const action = el.getAttribute("data-tracking-action");
					const adjustEventName = action
						.replace(/\s-\s|\s/g, "-")
						.toLowerCase();
					const props = el.getAttribute("data-tracking-properties");
					const obj = props ? JSON.parse(props) : {};

					if (adjustEvents[adjustEventName]) {
						el.addEventListener("click", () => {
							window.Adjust.trackEvent({
								eventToken: adjustEvents[adjustEventName],
							});
						});
					}
					trackLink(el, action, obj);
				});

			enhanceLoginForm(track);
		});
	}

	// ---------------- RudderStack ----------------
	function initRudder() {
		window.rudderanalytics.ready(() => {
			if (userId && optInAnalytics) window.rudderanalytics.identify(userId);
		});
	}

	if (window.analytics) initSegment();
	if (window.rudderanalytics) initRudder();

	// Main navigation - make opaque as user scrolls
	stickyHeader();

	// Verify email page
	if (document.querySelector(".verify__new-link")) {
		document
			.querySelector(".verify__new-link")
			.addEventListener("click", function() {
				return fetch(`/proxy/v1/verify`, { method: "POST" })
					.then(checkFetchForError)
					.then(parseFetchResponse)
					.then(function() {
						document
							.querySelector(".verify__sent-copy")
							.classList.remove("hide");
					})
					.catch(function() {});
			});
	}

	// Mobile navigation toggle
	var navWrapper = document.querySelector(".main-nav__wrapper");

	if (navWrapper) {
		document
			.querySelectorAll(".main-nav__toggle")
			.forEach(function(element) {
				element.addEventListener("click", function(e) {
					e.stopPropagation();

					const mobileNavIsOpen = navWrapper.classList.contains(
						"main-nav__wrapper--mobile-open"
					);

					document
						.querySelector(".main-nav__nav-menu")
						.setAttribute("aria-expanded", !mobileNavIsOpen);

					if (mobileNavIsOpen) {
						navWrapper.removeAttribute("open");
						clearAllBodyScrollLocks();
					} else {
						navWrapper.open = true;
						disableBodyScroll(navWrapper);
					}

					document
						.querySelector(".main-nav__mobile-overlay")
						.classList.toggle("main-nav__mobile-overlay--hidden");
					navWrapper.classList.toggle(
						"main-nav__wrapper--mobile-open"
					);
				});
			});
	}

	// Content card
	document
		.querySelectorAll(".content-card__container--link")
		.forEach(function(element) {
			element.addEventListener("click", function() {
				window.location.href = this.getAttribute("data-link");
			});
		});

	document.addEventListener("DOMContentLoaded", () => {
		var teacherSliderElement = document.querySelector(
			".teacher__slider-redesign"
		);
		var modalitySliderElement = document.querySelector(
			".modality-shelf__slider"
		);
		var modalityCarouselElement =
			document.querySelector(".modality-carousel");
		var countTheWaysSliderElement = document.querySelector(
			".count-the-ways__slider"
		);

		if (teacherSliderElement) {
			makeSlider(teacherSliderElement);
		}

		if (modalitySliderElement) {
			makeSlider(modalitySliderElement);
		}

		if (modalityCarouselElement) {
			makeSlider(modalityCarouselElement, true);
		}

		if (countTheWaysSliderElement) {
			makeSlider(countTheWaysSliderElement);
		}
	});

	var iterableOptinForm = document.getElementById("iterable-optin");

	if (iterableOptinForm) {
		iterableOptinForm.addEventListener("submit", function(e) {
			e.preventDefault();

			var email = iterableOptinForm
				.querySelector('input[type="email"]')
				.value.trim();

			if (!email) return;

			var options = {
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				method: "POST",
				body: JSON.stringify({
					email: email,
				}),
			};

			fetch(`/emailSignup`, options)
				.then(checkFetchForError)
				.then(function() {
					iterableOptinForm.innerHTML = `
						<h3 class="f-medium">✔️ Got it – we'll keep in touch!</h3>
					`;
				})
				.catch(function() {}); // Fail silently - would rather not expose errors on the homepage of all places :)
		});
	}
})();
